<div class="flex w-full" [formGroup]="form">
    <div>
        <avatar-component [name]="authUserName"></avatar-component>
    </div>
    <div class="flex-1 border rounded-l-2xl ml-1 p-2">
        <input
            class="w-full h-full leading-loose"
            type="text"
            placeholder="Écrire un commentaire"
            matInput formControlName="content"
            (keyup.enter)="sendComment()"
        />
    </div>
    <div class="border rounded-r-2xl p-2 leading-loose cursor-pointer" (click)="sendComment()">
        <mat-icon
            class="icon-size-5 rotate-90 align-middle"
            [svgIcon]="'heroicons_solid:paper-airplane'"
        ></mat-icon>
    </div>
</div>
